import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from '../redux/actions'
import SearchBar from "./SearchBar";
import { NavLink } from "react-router-dom"
import LogAdmin from "./LogAdmin";


const Nav = () => {


    return (
        <div class="navBack">
            <div class="navtop">
                <div class="searchBarContainer">
                    <SearchBar />
                </div>
                <div>
                    <LogAdmin />
                </div>
            </div>
            
                <div class="nav">


                    <NavLink class="bgw" to='/lmi/home'><div class="navoption">Inicio</div></NavLink>
                    <NavLink to='/lmi/players'><div class="navoption bgw">Jugadores</div></NavLink>
                    <NavLink to='/lmi/teams'><div class="navoption">Equipos</div></NavLink>
                    <NavLink to='/lmi/tournaments'><div class="navoption">Torneos</div></NavLink>
                    <NavLink to='/lmi/games'><div class="navoption">Juegos</div></NavLink>

                    </div>
           
        </div>
    )
}

export default Nav